import * as React from "react";
import {Fragment} from "react";
import LeadAgentChangeNotification from "../../../model/notification/assignee/LeadAgentChangeNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: LeadAgentChangeNotification
}

/**
 * Agent change notification toast body.
 */
const NotificationAgentChangeBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Lead {props.notification.data.getLeadReferenceNumber()}</div>
			<div className={"toast-body"}>
				Agent changed from <b>{props.notification.displayPreviousAssignee()} </b>
				to <b>{props.notification.displayCurrentAssignee()}</b>
			</div>
		</Fragment>
	);
};

export default NotificationAgentChangeBody;